import { Card, type CardProps } from "@mantine/core"
import type { ReactNode } from "react"

export function AppCard({
  children,
  className,
  p = "lg",
  ...props
}: CardProps & { children: ReactNode }) {
  return (
    <Card className={className} withBorder radius="sm" p={p} {...props}>
      {children}
    </Card>
  )
}
